import React from "react";

import NEEDLE from "../assets/needle.png";
import PILL from "../assets/pill.png";
import GEL from "../assets/gel.png";

const ExpandableContentSection = (props) => {
  const [active, setActive] = React.useState(-1);

  const handleOptionClick = (index) => {
    if (active === index) {
      setActive(-1);
    } else {
      setActive(index);
    }
  }

  const getAllOptions = () => {
    return props.data.map((item, index) => 
      <button className="content-option content-option-btn" key={`option${index}`} onClick={() => handleOptionClick(index)}>
        <div className="content-option-btn-title">
          <img className="forms-icon" src={item.img}/>
          {item.title}
        </div>
      </button>
    );
  }

  const getExpandedBox = () => {
    if (active === -1) {
      return <></>;
    }

    return (
      <div className="content-option-popup">
        <p>{props.data[active].description}</p>
      </div>
    )
  }

  return (
    <div>
      <div className="content-options">
        {getAllOptions()}
      </div>
      {getExpandedBox()}
    </div>
  );
}

const COMMON_FORMS = [
  {
    title: "Intramuscular steroid injections (IM)",
    img: NEEDLE,
    description: "Steroids are injected into muscle. This is the most common method of testosterone use. Some risks include injection-associated infections, abscesses, soft tissue damage, and nerve damage. If sharing needles, there are also risks of contracting HIV and Hepatitis C."
  },
  {
    title: "Oral steroid pills (PO)",
    img: PILL,
    description: "Steroids are administered as a pill. Oral steroids are often metabolized by the liver and can often cause liver injury."
  },
  {
    title: "Steroid patches and gels",
    img: GEL,
    description: "Testosterone is absorbed into the body through a patch or gel applied to the skin. This is the safest route of steroid use, but patches can fall off and gels can discolor clothing, sheets, etc."
  }
]


const CommonForms = () => {
  return (
    <section className="content-section">
      <h2>Common forms of steroids</h2>
      <p>
        Steroids come in many forms, and we will only cover a few below. Click each category to learn more.
      </p>
      <ExpandableContentSection data={COMMON_FORMS}/>
    </section>
  )
}

export default CommonForms;
